<template src="./RenunciaForm.html"></template>

<script>
import {
  Breadcrumb,
  BreadcrumbItem,
  Button,
  DatePicker,
  Divider,
  Form,
  FormItem,
  Input,
  Option,
  Select,
  Switch
} from 'element-ui'
import {mapState} from "vuex"
import ScreenSizeMixin from "@/mixins/ScreenSizeMixin";
import {NotifyMixin} from "@/mixins/NotifyMixin";
import moment from 'moment-timezone'
import {utils} from "@/utils";
import {servelService} from "@/api/servelApi";
import {requestRenunciaMixin} from "@/api/ciudadano/renunciaApi";

export default {
  name: "RenunciaForm",
  mixins: [
    requestRenunciaMixin,
    ScreenSizeMixin,
    NotifyMixin
  ],
  components: {
    [Form.name]: Form,
    [FormItem.name]: FormItem,
    [DatePicker.name]: DatePicker,
    [Button.name]: Button,
    [Option.name]: Option,
    [Select.name]: Select,
    [Input.name]: Input,
    [Breadcrumb.name]: Breadcrumb,
    [BreadcrumbItem.name]: BreadcrumbItem,
    [Switch.name]: Switch,
    [Divider.name]: Divider,
  },
  data() {
    const validateNumeroDocumento = (rule, value, callback) => {
      this.$log.debug('validateNumeroDocumento')
      if (!value) {
        callback(new Error('El número de documento es obligatorio'));
      } else if (!/^[A-Z0-9]{1,3}(\.[A-Z0-9]{3}){2}$/.test(value)) {
        callback(new Error('El formato debe ser XXX.XXX.XXX (letras y/o números)'));
      } else {
        // Validar contra la API de Servel
        // Formatear el RUT: sin puntos pero con guión y dígito verificador
        const rutLimpio = utils.rutClean(this.model.rut)
        const rutFormateado = rutLimpio.substring(0, rutLimpio.length - 1) + '-' + rutLimpio.substring(rutLimpio.length - 1)
        // Número de documento sin puntos
        const nDocumentoLimpio = value.replace(/\./g, '')
        console.log('Validando cédula:', rutFormateado, nDocumentoLimpio)
        servelService.validarCedula(rutFormateado, nDocumentoLimpio)
          .then(response => {
            this.$log.debug('validarCedula response', response);
            if (response.data && response.data.statusCode === 200 && response.data.body && response.data.body.success) {
              const data = response.data.body.data;
              // Verificar que el documento esté vigente y no bloqueado
              if (data.validityStatus === 'VIGENTE' && data.status === 'NO BLOQUEADO') {
                this.isDocumentoValidado = true;
                callback();
              } else if (data.validityStatus !== 'VIGENTE') {
                this.isDocumentoValidado = false;
                callback(new Error('El documento no está vigente'));
              } else if (data.status !== 'NO BLOQUEADO') {
                this.isDocumentoValidado = false;
                callback(new Error('El documento está bloqueado'));
              } else {
                this.isDocumentoValidado = false;
                callback();
              }
            } else if (response.data && response.data.statusCode === 400) {
              this.isDocumentoValidado = false;
              callback(new Error('El número de documento no corresponde al RUT ingresado'));
            } else {
              this.isDocumentoValidado = false;
              callback(new Error('Error al validar el documento'));
            }
          })
          .catch(error => {
            this.$log.error('Error al validar cédula', error);
            this.isDocumentoValidado = false;
            if (error.response && error.response.data && error.response.data.statusCode === 400) {
              callback(new Error('El número de documento no corresponde al RUT ingresado'));
            } else {
              // Si hay error en la comunicación, no permitir continuar
              callback(new Error('Error de conexión al validar el documento. Intente nuevamente.'));
            }
          });
      }
    };
    const validateConfirmacionEmail = (rule, value, callback) => {
      this.$log.debug('validateConfirmacionEmail')
      if (value === '') {
        callback(new Error('El correo electrónico es obligatorio'));
      } else if (value !== this.model.email) {
        callback(new Error('El correo electrónico no coincide'));
      } else {
        callback();
      }
    };
    const validateAcepta = (rule, value, callback) => {
      this.$log.debug('validateAcepta')
      if (value === '' || value === false) {
        callback(new Error('Debe aceptar la Declaración'));
      } else {
        callback();
      }
    };
    return {
      errored: false,
      isAceptaValido: true,
      loading: true,
      usuarioDomicilio: null,
      isDocumentoValidado: false,
      model: {
        rut: '',
        nombre: '',
        fechaNacimiento: '',
        domicilio: '',
        email: '',
        confirmacionEmail: '',
        telefonoMovil: '',
        telefonoFijo: '',
        ndocumento: '',
        acepta: false,
      },
      rules: {
        rut: [
          {
            length: 10,
            message: 'El RUT es obligatorio',
            trigger: 'blur'
          }
        ],
        nombre: [
          {
            min: 3,
            message: 'El nombre es obligatorio',
            trigger: 'blur'
          }
        ],
        fechaNacimiento: [
          {
            required: true,
            message: 'La fecha de nacimiento es obligatoria',
            trigger: 'blur'
          },
          {
            type: 'date',
            length: 10,
            message: 'La fecha de nacimiento es obligatoria',
            trigger: ['blur', 'change']
          }
        ],
        domicilio: [
          {
            min: 3,
            message: 'El domicilio es obligatorio',
            trigger: 'blur'
          }
        ],
        email: [
          {
            required: true,
            message: 'El correo electrónico es obligatorio',
            trigger: 'blur'
          },
          {
            type: 'email',
            message: 'Ingrese un correo electrónico válido',
            trigger: ['blur', 'change']

          }
        ],
        confirmacionEmail: [
          {
            required: true,
            message: 'El correo electrónico es obligatorio',
            trigger: 'blur'
          },
          {
            type: 'email',
            message: 'Ingrese un correo electrónico válido',
            trigger: ['blur', 'change']

          },
          {
            validator: validateConfirmacionEmail,
            trigger: 'blur'
          }
        ],
        ndocumento: [
          {
            required: true,
            message: 'El número de documento es obligatorio',
            trigger: 'blur'
          },
          {
            validator: validateNumeroDocumento,
            trigger: 'blur' // Solo validar al salir del campo para evitar múltiples llamadas a la API
          }
        ],
        acepta: [
          {
            required: true,
            message: 'Debe aceptar la Declaración',
            trigger: ['blur', 'change']
          },
          {
            validator: validateAcepta,
            trigger: ['blur', 'change']
          }
        ],
      },
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        },
      }
    }
  },
  props: {
    partido: {
      type: Object,
      required: true,
      default: function () {
        return {}
      }
    },
  },
  beforeMount() {
    this.getUsuarioDomicilio()
    this.model.rut = this.user.current.rut
    this.model.nombre = this.user.current.nombreCompleto
    this.model.fechaNacimiento = this.user.current.fechaNacimiento
  },
  computed: {
    ...mapState({
      user: state => state.user,
    }),
    isValidFechaNacimiento: function () {
      if (this.user.current.fechaNacimiento)
        return moment(this.user.current.fechaNacimiento, 'DD-MM-YYYY').isValid()
      return false
    },
  },
  methods: {
    goBack() {
      this.$emit('on-back')
    },
    validate() {
      this.$refs['renunciaForm']
        .validate((valid) => {
          if (valid) {
            this.$log.debug("enviando...")
            const loading = this.getLoading()

            this.enviarRenunciaCiudadano(loading)
              .then(response => {
                this.$log.debug('enviarRenunciaCiudadano', response)

                this.$emit('on-created', valid, response)

                loading.close()
              })

          } else {
            this.$log.debug('error submit!!')
          }
        });
    },
    getDataFromPartidoSeleccionado(data = {}) {
      data.partido_id = this.partido.partido_id
      data.partido_nombre = this.partido.partido_nombre
      data.fecha_afiliacion = this.partido.fecha_afiliacion
    },
    getDataFromModelForm(data = {}) {
      data.run = this.$store.state.user.current.cedula
      data.dv = this.$store.state.user.current.dv
      data.materno = this.$store.state.user.current.materno
      data.nombres = this.$store.state.user.current.nombres
      data.paterno = this.$store.state.user.current.paterno
      data.fecha_nacimiento = this.model.fechaNacimiento
      data.email = this.model.email
      data.telefono_fijo = this.model.telefonoFijo
      data.telefono_movil = this.model.telefonoMovil
      data.numero_documento = this.model.ndocumento
    },
    getDataFromDomicilio(data = {}) {
      data.calle = this.usuarioDomicilio.calle
      data.comuna = this.usuarioDomicilio.nombre_comuna
      data.region = this.usuarioDomicilio.nombre_region
      data.numero = this.usuarioDomicilio.numero
      data.pais = this.usuarioDomicilio.glosa_pais
    },
    generarData() {
      let data = {}

      this.getDataFromPartidoSeleccionado(data)
      this.getDataFromModelForm(data)
      this.getDataFromDomicilio(data)

      return data;
    },
    enviarRenunciaCiudadano(loading) {
      let data = this.generarData();
      this.$log.debug('enviarRenunciaCiudadano', data)

      return this.enviarRenuncia(data)
        .then(response => {
          this.$log.debug('enviarRenuncia', response.data.statusCode)

          loading.close();
          if (response.data.statusCode === 201) {
            return true
          } else {
            this.showError('Ocurrió un error inesperado al enviar la renuncia.')
            return false
          }
        })
        .catch(err => {
          this.$log.fatal('enviarRenuncia', err, err.response, err.request)

          loading.close();
          this.showError('Ocurrió un error inesperado al enviar la renuncia')
          return false
        })
    },
    getUsuarioDomicilio() {
      servelService.getRegistrodomicilio()
        .then(response => {
          this.$log.debug('getRegistrodomicilio', response.data.statusCode)

          if (response.data.statusCode === 200) {
            const data = response.data.datos;
            this.$log.debug(data)
            this.usuarioDomicilio = data;

            this.model.domicilio = utils.capitalize(
              `${data.calle}, ` +
              `${data.numero}, ` +
              `${data.nombre_comuna}, ` +
              `${data.nombre_region}`)
          } else {
            this.errored = true
            this.showError('Ocurrió un error inesperado al cargar los datos del domicilio')

            this.$emit('on-error')
          }
          this.loading = false
        })
        .catch(err => {
          this.$log.fatal('getRegistrodomicilio', err, err.response, err.request)
          this.errored = true
          this.loading = false
          this.showError('Ocurrió un error inesperado al cargar los datos del domicilio')

          this.$emit('on-error')
        });
    },
    formatNumeroDocumento(value) {
      // Resetear estado de validación cuando se modifica el campo
      this.isDocumentoValidado = false;
      
      // Convertir a mayúsculas y eliminar caracteres no alfanuméricos excepto puntos
      let cleaned = value.toUpperCase().replace(/[^A-Z0-9.]/g, '');

      // Eliminar puntos para reformatear
      cleaned = cleaned.replace(/\./g, '');

      // Limitar a 9 caracteres alfanuméricos
      cleaned = cleaned.substring(0, 9);

      // Formatear con puntos cada 3 caracteres
      let formatted = '';
      if (cleaned.length > 0) {
        formatted = cleaned.substring(0, 3);
        if (cleaned.length > 3) {
          formatted += '.' + cleaned.substring(3, 6);
        }
        if (cleaned.length > 6) {
          formatted += '.' + cleaned.substring(6, 9);
        }
      }

      // Actualizar el modelo
      this.model.ndocumento = formatted;
    }
  }
}

</script>
